import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2436bcf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Thank you", -1))
const _hoisted_3 = { style: {"margin":"24px 0"} }
const _hoisted_4 = {
  key: 2,
  style: {"text-align":"right"}
}

import { ref } from 'vue';
import { Popover } from 'ant-design-vue';
import { QuestionOutlined } from '@ant-design/icons-vue';
import { ButtonWithIcon, Button, Text } from '@/shared/ui';
import Title from './ui/Title.vue';
import { ProxyForm } from '@/features';
import formConfig from './form-config';
import { toast } from '@/shared/lib';


export default /*#__PURE__*/_defineComponent({
  __name: 'SupportFormButton',
  setup(__props) {

const open = ref(false);
const success = ref(false)
const ticket = ref(false)
const form = ref()
const loading = ref(false)
function openHandler() {
  open.value = !open.value;
  form.value?.clearValidate()
}
async function submithandler() {
  loading.value = true;
  form.value.submit().then((response : any) => {
    ticket.value = response?.data?.data.ticket;
    success.value = true;
  }).finally(() => {
    loading.value = false;
  }).catch((err : any) => {
    toast({ type: 'error', msg: err })
    loading.value = false;
  })
}
function closeDelay() {
  open.value = false;
  setTimeout(() => {
    success.value = false;
  }, 500);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popover), {
    visible: open.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((open).value = $event)),
    trigger: "click",
    overlayClassName: 'supportPopover',
    placement: 'bottomRight'
  }, {
    title: _withCtx(() => [
      (!success.value)
        ? (_openBlock(), _createBlock(Title, {
            key: 0,
            onClose: openHandler,
            style: {"color":"#003F87"}
          }))
        : _createCommentVNode("", true)
    ]),
    content: _withCtx(() => [
      (success.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(Text), { class: "ThankYou" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("p", _hoisted_3, "Your support request #" + _toDisplayString(ticket.value) + " has been successfully submitted. Our team will review your inquiry and get back to you as soon as possible", 1),
                _createVNode(_unref(Button), { onClick: closeDelay }, {
                  default: _withCtx(() => [
                    _createTextVNode("Okay")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createBlock(_unref(ProxyForm), {
            key: 1,
            ref_key: "form",
            ref: form,
            formConfig: _unref(formConfig),
            onError: _cache[0] || (_cache[0] = ($event: any) => (loading.value=false))
          }, null, 8, ["formConfig"])),
      (!success.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(Button), {
              type: 'default',
              style: {"margin-right":"20px"},
              onClick: openHandler
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              onClick: submithandler,
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit")
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(ButtonWithIcon), {
        type: 'default',
        text: 'Support',
        class: "supportButton",
        onClick: openHandler
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(QuestionOutlined), { class: "icon" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})